import { AfterContentInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AwallComponentEvent } from '../../../../models/awallComponentEvent';
import { UserstoryService } from '../../../../services/userstory.service';
import { SettingsService } from '../../../../services/settings.service';
import { AbstractKanbanGrid } from '../AbstractKanbanGrid';
import { Listener, CommunicationService } from '../../../../services/communication.service';

@Component({
  selector: 'app-kanban-grid-default',
  templateUrl: './kanban-grid-default.component.html',
  styleUrls: ['./kanban-grid-default.component.scss']
  })
export class KanbanGridDefaultComponent extends AbstractKanbanGrid implements OnInit, OnDestroy, AfterContentInit,
  Listener<AwallComponentEvent> {

  @ViewChild('kanbanDefaultSwimlane') input;
  constructor(
    protected communicationService: CommunicationService,
    protected userStoryService: UserstoryService,
    protected settingsService: SettingsService
  ) {
    super(communicationService, userStoryService, settingsService);
  }

  ngOnInit() {
  }

  public prepareIssues(userStoriesData) {
    this.taskboardData = [];
    this.expediteLaneData = [];

    // Normal lanes
    userStoriesData.forEach(story => {
      const storyEntry = {};
      storyEntry['userstory'] = story;
      storyEntry['columns'] = [];

      let index = 0;

      this.data.boardConfiguration.columns.forEach(column => {
        const columnEntry = {};

        columnEntry['name'] = column.name;
        // TODO handling for columns with multiple statuses will need to be determinded at a later point in time
        columnEntry['id'] = column.statuses[0].id;
        columnEntry['type'] = column.getStatusCategoryKey();
        columnEntry['tasks'] = [];
        columnEntry['tasks'].id = index++;

        // add the issue itself to the column
        if (column.statusMatchesIssue(story)) {
          if (this.data.expediteLane && !story.isExpedited) {
            columnEntry['tasks'].push(story);
          } else if (!this.data.expediteLane) {
            columnEntry['tasks'].push(story);
          }
        }

        // add the subtasks to the columns
        story.tasks.forEach(subtask => {
          if (column.statusMatchesIssue(subtask)) {
            if (this.data.expediteLane && !story.isExpedited) {
              columnEntry['tasks'].push(subtask);
            } else if (!this.data.expediteLane) {
              columnEntry['tasks'].push(subtask);
            }
          }
        });
        storyEntry['columns'].push(columnEntry);
      });

      if (this.data.expediteLane && !story.isExpedited) {
        this.taskboardData.push(storyEntry);
      } else if (!this.data.expediteLane) {
        this.taskboardData.push(storyEntry);
      }
    });

    // Expedite lanes
    userStoriesData.forEach(story => {
      const storyEntry = {};
      storyEntry['userstory'] = story;
      storyEntry['columns'] = [];

      let index = 0;

      this.data.boardConfiguration.columns.forEach(column => {
        const columnEntry = {};

        columnEntry['name'] = column.name;
        // TODO handling for columns with multiple statuses will need to be determinded at a later point in time
        columnEntry['id'] = column.statuses[0].id;
        columnEntry['type'] = column.getStatusCategoryKey();
        columnEntry['tasks'] = [];
        columnEntry['tasks'].id = index++;

        // add the issue itself to the column
        if (column.statusMatchesIssue(story) && (story.isExpedited && this.data.expediteLane)) {
          columnEntry['tasks'].push(story);
        }

        // add the subtasks to the columns
        story.tasks.forEach(subtask => {
          if (column.statusMatchesIssue(subtask) && (story.isExpedited && this.data.expediteLane)) {
            columnEntry['tasks'].push(subtask);
          }
        });
        storyEntry['columns'].push(columnEntry);
      });

      if (story.isExpedited && this.data.expediteLane) {
        this.expediteLaneData.push(storyEntry);
      }
    });
  }
}
